import RequestService from '../../../services/request-service';
import DateFilterService from '../../../services/date-filter-service';

/**
 * Service for getting fixture menu
 */
export default class BetBuilderFixtureRequestService extends RequestService {
  /**
   * Class constructor method
   * @param dateFilter filtering records by time period
   */
  constructor(dateFilter) {
    super();
    this.method = 'get';
    this.endpoint = this.$config.endpoints.betBuilderFixtureMenu;
    const { Culture } = this.$config.defaultHeaders;
    this.getParams = {
      LoadPeriod: DateFilterService.parseDateFilter(dateFilter),
      // eslint-disable-next-line no-undef
      culture: Culture,
      // TimeOffset: DateFilterService.utcTimeOffset(),
    };
    this.headers = null;
  }
}
